
/**
 * Women Spot Header Controller
 * Handles mobile drawer toggles, AJAX cart drawer redirection,
 * scroll-up sticky header, and search modals.
 */

document.addEventListener('DOMContentLoaded', function () {

  // ==========================================
  // 1. MOBILE MENU DRAWER CONTROLLER
  // ==========================================
  const hamburgerBtn = document.getElementById('women-spot-hamburger-btn');
  const navDrawer = document.getElementById('women-spot-header-nav');
  const navOverlay = document.getElementById('women-spot-menu-overlay');
  const menuCloseBtn = document.getElementById('women-spot-menu-close');

  function toggleMobileMenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (navDrawer) navDrawer.classList.toggle('active');
    if (navOverlay) navOverlay.classList.toggle('active');

    if (navDrawer && navDrawer.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', toggleMobileMenu);
  }

  if (menuCloseBtn) {
    menuCloseBtn.addEventListener('click', toggleMobileMenu);
  }

  if (navOverlay) {
    navOverlay.addEventListener('click', toggleMobileMenu);
  }

  window.womenSpotToggleMobileMenu = toggleMobileMenu;

  // ==========================================
  // 2. STICKY HEADER
  // ==========================================
  const headerWrapper = document.getElementById('WomenSpotHeader');
  let lastScrollTop = 0;

  if (headerWrapper) {
    window.addEventListener(
      'scroll',
      function () {
        let currentScroll =
          window.pageYOffset ||
          document.documentElement.scrollTop;

        if (currentScroll > 150) {
          headerWrapper.classList.add('is-sticky');

          if (currentScroll > lastScrollTop) {
            headerWrapper.classList.add('is-hidden');
          } else {
            headerWrapper.classList.remove('is-hidden');
          }
        } else {
          headerWrapper.classList.remove('is-sticky');
          headerWrapper.classList.remove('is-hidden');
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      },
      { passive: true }
    );
  }

  // ==========================================
  // 3. AJAX CART DRAWER - UPDATED
  // ==========================================
  const customCartIcon = document.getElementById('women-spot-cart-icon');

  if (customCartIcon) {
    let cartOpening = false;

    customCartIcon.addEventListener('click', async function (e) {
      const drawer = document.querySelector('cart-drawer');

      if (!drawer) return;

      e.preventDefault();

      if (cartOpening) return;
      cartOpening = true;

      try {
        const root = window.Shopify?.routes?.root || '/';

        const response = await fetch(
          root + 'cart?section_id=cart-drawer',
          {
            credentials: 'same-origin',
            cache: 'no-store'
          }
        );

        if (!response.ok) {
          throw new Error('Unable to refresh cart drawer');
        }

        const html = await response.text();

        const parsed = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const updatedDrawer = parsed.querySelector('#CartDrawer');
        const currentDrawer = drawer.querySelector('#CartDrawer');

        if (!updatedDrawer || !currentDrawer) {
          throw new Error('Cart drawer HTML not found');
        }

        currentDrawer.innerHTML = updatedDrawer.innerHTML;

        const updatedCart = parsed.querySelector('cart-drawer');
        const isEmpty = updatedCart
          ? updatedCart.classList.contains('is-empty')
          : false;

        drawer.classList.toggle('is-empty', isEmpty);

        if (typeof drawer.open === 'function') {
          drawer.open(customCartIcon);
        } else {
          drawer.classList.add('active', 'is-active');
        }

      } catch (error) {
        console.error('Women Spot cart refresh error:', error);
        window.location.href = customCartIcon.href;
      } finally {
        cartOpening = false;
      }
    });
  }

  // ==========================================
  // 4. ESCAPE KEY
  // ==========================================
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (typeof window.womenSpotCloseSearch === 'function') {
        window.womenSpotCloseSearch();
      }

      if (navDrawer && navDrawer.classList.contains('active')) {
        toggleMobileMenu();
      }
    }
  });

});


// ==========================================
// 5. OPEN SEARCH
// ==========================================

function womenSpotSetSearchPosition() {
  const headerWrapper =
    document.getElementById('WomenSpotHeader');

  const searchModal =
    document.getElementById('women-spot-floating-search');

  if (!searchModal) return;

  let headerBottom = 0;

  if (headerWrapper) {
    const headerPosition =
      headerWrapper.getBoundingClientRect();

    headerBottom = Math.max(
      0,
      headerPosition.bottom
    );
  }

  searchModal.style.top =
    Math.round(headerBottom) + 'px';
}

window.womenSpotOpenSearch = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const searchModal =
    document.getElementById('women-spot-floating-search');

  const searchInput =
    document.getElementById('women-spot-search-input');

  const headerWrapper =
    document.getElementById('WomenSpotHeader');

  const navDrawer =
    document.getElementById('women-spot-header-nav');

  const navOverlay =
    document.getElementById('women-spot-menu-overlay');

  const hamburgerBtn =
    document.getElementById('women-spot-hamburger-btn');

  /*
   * Close mobile menu before opening search.
   */
  if (navDrawer) {
    navDrawer.classList.remove('active');
  }

  if (navOverlay) {
    navOverlay.classList.remove('active');
  }

  if (hamburgerBtn) {
    hamburgerBtn.setAttribute(
      'aria-expanded',
      'false'
    );
  }

  /*
   * Keep header visible when search opens.
   */
  if (headerWrapper) {
    headerWrapper.classList.remove(
      'is-hidden'
    );
  }

  document.body.style.overflow = '';

  /*
   * Position search below the header.
   */
  womenSpotSetSearchPosition();

  if (searchModal) {
    searchModal.classList.add('active');

    searchModal.setAttribute(
      'aria-hidden',
      'false'
    );

    window.setTimeout(function () {
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  }
};

// ==========================================
// 6. CLOSE SEARCH
// ==========================================

window.womenSpotCloseSearch = function () {
  const searchModal =
    document.getElementById('women-spot-floating-search');

  if (searchModal) {
    searchModal.classList.remove(
      'active'
    );

    searchModal.setAttribute(
      'aria-hidden',
      'true'
    );
  }
};

/*
 * Update search position when screen size changes.
 */
window.addEventListener(
  'resize',
  function () {
    const searchModal =
      document.getElementById('women-spot-floating-search');

    if (
      searchModal &&
      searchModal.classList.contains(
        'active'
      )
    ) {
      womenSpotSetSearchPosition();
    }
  },
  { passive: true }
);
